import {Component} from "../interface/component";
import {AbstractPostListLoadMore} from "./abstract-post-list-load-more";

export class ArticlesComponent extends AbstractPostListLoadMore implements Component {
    private $root: JQuery;
    private $container: JQuery;
    private $search_form:JQuery;
    private $sort_form:JQuery;

    private $pages_container:JQuery;
    private $pages:JQuery;
    private $page_element:JQuery;

    private $search_results_container_container: JQuery;
    private $search_results_container: JQuery;
    private $search_results:JQuery;
    private $search_results_noun:JQuery;
    private search_results_singular: string;
    private search_results_plural: string;

    private $search_keyword:JQuery;
    private $search_submit:JQuery;
    private $search_clear:JQuery;
    private $search_selects:JQuery;
    private current_page:number;
    private max_pages:number;
    private num_posts:number;
    private has_more_pages:Boolean = true;
    private url:string;
    private should_update_address_bar:boolean = true;

    constructor(elem: HTMLElement) {
        super(elem);
        this.$root = $(elem);
        this.$container = this.$root.find('.js-articles-container');
        this.$search_form = this.$root.find('.js-listing-search-form');
        this.$sort_form = this.$root.find('.js-listing-sort-form');
        this.$search_results_container_container = this.$root.find('.js-form-message-container')
        this.$search_results_container = this.$root.find('.js-form-message');
        this.$search_results = this.$root.find('.js-search-results');
        this.$search_results_noun = this.$root.find('.js-search-results-noun')
        this.$search_keyword = this.$root.find('.js-search-keyword');
        this.$search_submit = this.$root.find('.js-listing-search-form-submit');
        this.$search_clear = this.$root.find('.js-clear-search');
        this.$search_selects = this.$root.find('select');
        this.$pages_container = this.$root.find('.js-pagination-container');
        this.url = this.$search_form.data('url');

        this.search_results_plural = this.$search_results_container.data('plural');
        this.search_results_singular = this.$search_results_container.data('singular');

        if (this.$search_form.data('no-address-bar-update') || !this.url){
            this.should_update_address_bar = false;
        }
        this.updateDataFromDataAttributes(this.$container);
        this.attachPaginationEvents();
    }

    public init = () => {
        this.$load_more.on({click: this.loadMore});
        this.$search_form.on({submit: this.refreshPosts});
        this.$sort_form.on({submit: this.refreshPosts});
        this.$search_clear.on({click: this.clearSearch});
        this.handleMaxPagesReached();
    }

    private loadMore = (ev:Event) => {
        ev.preventDefault();
        if (this.has_more_pages) {
            let action = this.$search_form.attr('action');
            let data = this.$search_form.serializeArray().concat(this.$sort_form.serializeArray());
            let next_page = this.current_page + 1;
            data.push({name: "paged", value: next_page.toString()});
            this.handleLoading();
            $.get(action, data, this.onLoadMoreResponse);
            this.updateAddressBar(this.url, data);
        }
    }

    private attachPaginationEvents = () => {
        this.$pages = this.$root.find('.js-page-link');
        this.$pages.on({'click': this.onPageClick});
    }

    private onPageClick = (ev:Event) => {
        ev.preventDefault();
        let $element = $(ev.currentTarget);
        let page = $element.attr('data-page');
        let action = this.$search_form.attr('action');
        let data = this.$search_form.serializeArray().concat(this.$sort_form.serializeArray());
        data.push({name: "paged", value: page});
        this.$search_submit.addClass('c-form-submit--submitting');
        this.updateAddressBar(this.url, data)
        $.get(action, data, this.onUpdateSearchResponse);
    }

    private clearSearch = (ev:Event) => {
        ev.preventDefault();
        this.$search_form.find('input[type=text],input[type=search]').val('');
        this.$search_form.find('option').removeAttr('selected');
        try {
            //@ts-ignore
            this.$search_form.find('select').selectric('refresh');
        } catch (e){
            //no selectric
        }
        this.refreshPosts(ev);
    }

    private refreshPosts = (ev:Event) => {
        ev.preventDefault();
        let action = this.$search_form.attr('action');
        let data = this.$search_form.serializeArray().concat(this.$sort_form.serializeArray());
        data.push({name: "paged", value: "1"});
        this.$search_submit.addClass('c-form-submit--submitting');
        this.updateAddressBar(this.url, data)
        $.get(action, data, this.onUpdateSearchResponse);
    }

    private onLoadMoreResponse = (data:any) => {
        this.$load_more.removeClass('u-btn--load-more-is-loading');
        let response = $(data).find('.js-articles-container').addBack('.js-articles-container');
        let new_posts = response.children();
        this.updateDataFromDataAttributes(response);
        new_posts.fadeOut(0, "linear");
        this.$container.append(new_posts);
        this.fadeInPosts(new_posts);
        this.handleMaxPagesReached();
        this.updateResultsMessage();
    }

    private onUpdateSearchResponse = (data:any) => {
        this.$search_submit.removeClass('c-form-submit--submitting');
        let response = $(data).find('.js-articles-container');
        let existing_posts = this.$container.children();
        let new_posts = response.children();

        this.updateDataFromDataAttributes(response);
        new_posts.fadeOut(0, "linear");
        existing_posts.remove();
        this.$container.append(new_posts);
        this.fadeInPosts(new_posts);
        this.handleMaxPagesReached();
        this.updateResultsMessage();
        this.updateSearchKeyword();
        this.updatePages(data)
    }

    private updateSearchKeyword = () => {
        let keyword  = this.$root.find('[name=s],[name=post_search').val().toString();

        this.$search_keyword.text(keyword);
    }

    private handleMaxPagesReached = () => {
        this.handleLoaded(this.current_page < this.max_pages);
        this.has_more_pages = this.current_page != this.max_pages;
    }

    private fadeInPosts = ($posts: JQuery) => {
        let timeout = 0;
        let timeout_per_post = 200;
        $posts.each((index:number, element:HTMLElement) => {
            setTimeout(() => {
                $(element).fadeIn(timeout_per_post, "swing");
            }, timeout);
            timeout += timeout_per_post;
        });
    }

    private updateDataFromDataAttributes = ($element: JQuery) => {
        this.current_page = $element.data('current-page');
        this.max_pages = $element.data('max-pages');
        this.num_posts = $element.data('num-results');
    }

    private updateResultsMessage = () => {
        this.$search_results.text(this.num_posts);
        if (this.num_posts == 1){
            this.$search_results_noun.text(this.search_results_singular);
        }else{
            this.$search_results_noun.text(this.search_results_plural);
        }
        if (this.hasSearch()) {
            this.$search_clear.removeClass('hidden');
            this.$search_results_container.removeClass('u-hidden');
            this.$search_results_container_container.removeClass('c-wp-search__body--hide');
        }else{
            this.$search_clear.addClass('hidden');
            this.$search_results_container.addClass('u-hidden');
            this.$search_results_container_container.addClass('c-wp-search__body--hide');
        }
    }

    private hasSearch = () => {
        let has_search = this.$search_keyword.val();
        this.$search_selects.each((index, element) => {
            has_search = has_search || $(element).val();
        });
        return has_search;
    }

    private updateAddressBar = (action:string, data:Array<object>) => {
        if (!this.should_update_address_bar){
            return;
        }
        let url = new URL(action);
        data.forEach((o:any) => {
            if (o.name == 'paged'){
                return;
            }
            url.searchParams.append(o.name, o.value);
        });
        history.pushState({}, "", url.toString());
    }

    private updatePages = (data:any) => {
        let $response = $(data);
        let $pages = $response.find('.js-pagination-container').children();
        this.$pages_container.children().remove();
        this.$pages_container.append($pages);
        this.attachPaginationEvents();
    }
}